import React from "react";
import Moment from "react-moment";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter
} from "../../../../../../Components/Panel/Panel";
import { InputGroup, Input, InputGroupAddon, Button, Alert } from "reactstrap";
import Pagination from "../../../../../../Components/Pagination/QSP";
import Category from "./ListCategory";
import PerfectScrollbar from "react-perfect-scrollbar";

export default ({
  history,
  match,
  location,
  config,
  page,
  keyword,
  keywordInput,
  blockSize,
  first,
  data,
  loading,
  baseUrl,
  handleSearch
}) => {
  return (
    <>
      <Helmet>
        <title>1:1 문의 관리 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Home</Link>
          </li>
          <li className="breadcrumb-item active">1:1문의</li>
        </ol>
        <h1 className="page-header">1:1문의</h1>

        <div className="row">
          <div className="col-xs-12">
            <Panel>
              <PanelHeader>
                목록({!loading && data.AdminInquiryList.count}건)
              </PanelHeader>
              <Alert className="bg-gray-transparent-1">
                <Category
                  history={history}
                  match={match}
                  location={location}
                  config={config}
                />
                <div className="row m-t-15">
                  <div className="col-xs-12">
                    <form onSubmit={handleSearch}>
                      <InputGroup>
                        <Input
                          type="text"
                          className="input-white"
                          placeholder="검색어(이름) 입력"
                          value={keywordInput.value}
                          onChange={keywordInput.onChange}
                        />
                        <InputGroupAddon addonType="append">
                          <Button size="sm" color="white">
                            <i className="fa fa-search fa-fw"></i>
                          </Button>
                          <Link
                            to={`/inquiryConfigs/${match.params.CommonApp}/${config.AdminInquiryConfig.id}/edit${location.search}`}
                            className="btn btn-white"
                          >
                            <i className="fa fa-cog fa-fw"></i>
                          </Link>
                        </InputGroupAddon>
                      </InputGroup>
                    </form>
                  </div>
                </div>
              </Alert>

              {!loading && data.AdminInquiryList.count > 0 ? (
                <>
                  <PanelBody className="">
                    <PerfectScrollbar options={{ suppressScrollX: true }}>
                      <table className="table table-striped table-bordered table-th-valign-middle table-td-valign-middle m-b-0">
                        <colgroup>
                          <col style={{ width: "10%" }} />
                          <col style={{ width: "*" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "15%" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th className="text-center">상태</th>
                            <th className="text-center">제목</th>
                            <th className="text-center">작성자</th>
                            <th className="text-center">작성일</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.AdminInquiryList.inquiries.map(
                            (item, index) => {
                              return (
                                <tr key={index}>
                                  <td className="text-center">
                                    <label
                                      htmlFor=""
                                      className="label label-primary"
                                    >
                                      {item.commonStatus === "S"
                                        ? "답변대기"
                                        : "답변완료"}
                                    </label>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/inquiryConfigs/${match.params.CommonApp}/${config.AdminInquiryConfig.id}/inquiries/${item.id}${location.search}`}
                                    >
                                      {item.question}
                                    </Link>
                                  </td>
                                  <td className="text-center">
                                    {item.user.userId}({item.user.name})
                                  </td>
                                  <td className="text-center">
                                    <Moment format="YYYY-MM-DD HH:mm:ss">
                                      {item.createdAt}
                                    </Moment>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </PerfectScrollbar>
                  </PanelBody>
                  <PanelFooter>
                    <div className="row">
                      <div className="col-md-6">
                        <Pagination
                          totalRecord={data.AdminInquiryList.count}
                          blockSize={blockSize}
                          pageSize={first}
                          currentPage={page}
                          baseUrl={baseUrl}
                        />
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </PanelFooter>
                </>
              ) : (
                <PanelBody>
                  <p className="text-center">등록된 데이터가 없습니다.</p>
                </PanelBody>
              )}
            </Panel>
          </div>
        </div>
      </div>
    </>
  );
};
